export default __webpack_public_path__ + "static/media/012-delivery man.092ec46c.svg";